import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
};

/** ACL options for create moment tool and traceid v2 */
export type AclOptions = {
  __typename?: 'AclOptions';
  create_moment_tool?: Maybe<Scalars['Boolean']>;
  traceid_v2?: Maybe<Scalars['Boolean']>;
};

/**
 * A collection is a group of moments in a Trace iD Profile
 * maps to 'user_playlist_collections' table
 */
export type Collection = {
  __typename?: 'Collection';
  archived: Scalars['Boolean'];
  color?: Maybe<Scalars['Int']>;
  creation_time?: Maybe<Scalars['DateTime']>;
  hash_key: Scalars['String'];
  items?: Maybe<Array<Maybe<CollectionItem>>>;
  locked?: Maybe<Scalars['Boolean']>;
  num_items?: Maybe<Scalars['Int']>;
  permission?: Maybe<CollectionPermission>;
  position?: Maybe<Scalars['Int']>;
  public: Scalars['Boolean'];
  smart: Scalars['Boolean'];
  thumbnails?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  update_time?: Maybe<Scalars['DateTime']>;
  user_playlist_collection_id?: Maybe<Scalars['Int']>;
  user_playlist_id?: Maybe<Scalars['Int']>;
  view_count?: Maybe<Scalars['Int']>;
};

/** Response for adding a collection */
export type CollectionAddResponse = {
  __typename?: 'CollectionAddResponse';
  error: Scalars['String'];
  hash_key?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** All fields you can edit in a Collection object */
export type CollectionEdit = {
  archived?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  public?: Maybe<Scalars['Boolean']>;
  smart?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * A collection item is a HABTM mapping between Trace iD collections and soccer game moments
 * maps to 'user_playlist_clips' table
 */
export type CollectionItem = {
  __typename?: 'CollectionItem';
  clip_id?: Maybe<Scalars['Int']>;
  clip_type?: Maybe<Scalars['String']>;
  content_access?: Maybe<Scalars['String']>;
  creation_time?: Maybe<Scalars['DateTime']>;
  locked?: Maybe<Scalars['Boolean']>;
  moment?: Maybe<Moment>;
  position?: Maybe<Scalars['Int']>;
  update_time?: Maybe<Scalars['DateTime']>;
  user_playlist_clip_id?: Maybe<Scalars['Int']>;
  user_playlist_collection_id?: Maybe<Scalars['Int']>;
  user_playlist_id?: Maybe<Scalars['Int']>;
};

/** Data needed to add a moment to a trace id collection */
export type CollectionItemAdd = {
  /** The user_playlist_clip_id of the moment you want to add to the collection */
  user_playlist_clip_id: Scalars['Int'];
};

/** Response for adding an item to a collection */
export type CollectionItemAddResponse = {
  __typename?: 'CollectionItemAddResponse';
  error: Scalars['String'];
  success: Scalars['Boolean'];
  user_playlist_clip_id?: Maybe<Scalars['Int']>;
};

/** CollectionItemEdit contains all the editable fields of a CollectionItem */
export type CollectionItemEdit = {
  archived?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  spotlights?: Maybe<Array<Maybe<SpotlightEdit>>>;
  start_time?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<TagAdd>>>;
  title?: Maybe<Scalars['String']>;
  user_playlist_collection_id?: Maybe<Scalars['Int']>;
};

/** Collection Permissions */
export type CollectionPermission = {
  __typename?: 'CollectionPermission';
  archive: Scalars['Boolean'];
  collection_items_limit: Scalars['Int'];
  create: Scalars['Boolean'];
  download_video: Scalars['Boolean'];
  edit: Scalars['Boolean'];
  items_archive: Scalars['Boolean'];
  items_copy: Scalars['Boolean'];
  items_create: Scalars['Boolean'];
  items_edit: Scalars['Boolean'];
  items_move: Scalars['Boolean'];
  items_reorder: Scalars['Boolean'];
  list: Scalars['Boolean'];
  upload_video: Scalars['Boolean'];
  view: Scalars['Boolean'];
};

/** ContentAccess for a user. */
export type ContentAccess = {
  __typename?: 'ContentAccess';
  action?: Maybe<Scalars['String']>;
  allowed?: Maybe<Scalars['Boolean']>;
};


/** A divison that contains one or more teams */
export type Division = {
  __typename?: 'Division';
  division_id?: Maybe<Scalars['Int']>;
  is_member?: Maybe<Scalars['Boolean']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Response for mutations */
export type EditResponse = {
  __typename?: 'EditResponse';
  error: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FilterValue = {
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** A basic game information */
export type Game = {
  __typename?: 'Game';
  approx_half_duration?: Maybe<Scalars['Int']>;
  away_team?: Maybe<TeamInfo>;
  churned?: Maybe<Scalars['Boolean']>;
  full_date?: Maybe<Scalars['DateTime']>;
  game_id: Scalars['Int'];
  home_team?: Maybe<TeamInfo>;
  moments?: Maybe<Array<Maybe<Moment>>>;
  sport_type?: Maybe<Scalars['String']>;
};


/** A basic game information */
export type GameMomentsArgs = {
  hash_key: Scalars['String'];
};


/**
 * A moment is a segment of video
 * maps to 'game_clips' table
 */
export type Moment = {
  __typename?: 'Moment';
  away_team?: Maybe<TeamInfo>;
  base_path?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  dynamic_audio?: Maybe<Scalars['String']>;
  dynamic_duration?: Maybe<Scalars['Float']>;
  dynamic_hls?: Maybe<Scalars['String']>;
  dynamic_jfile?: Maybe<Scalars['String']>;
  dynamic_offset?: Maybe<Scalars['Float']>;
  dynamic_start?: Maybe<Scalars['Float']>;
  end_third?: Maybe<Scalars['String']>;
  game_clip_id?: Maybe<Scalars['Int']>;
  game_id?: Maybe<Scalars['Int']>;
  half?: Maybe<Scalars['Int']>;
  home_team?: Maybe<TeamInfo>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  parent_col_id?: Maybe<Scalars['Int']>;
  parent_ref_id?: Maybe<Scalars['Int']>;
  sport_type?: Maybe<Scalars['String']>;
  spotlights?: Maybe<Array<Maybe<Spotlight>>>;
  start_third?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['Float']>;
  storage_type?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  team_id?: Maybe<Scalars['Int']>;
  thirds?: Maybe<Array<Maybe<Scalars['String']>>>;
  time?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  trace_numbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

/** Information about collection and profile for a given moment (game_clip_id) */
export type MomentCollectionInfo = {
  __typename?: 'MomentCollectionInfo';
  collection_hash_key?: Maybe<Scalars['String']>;
  game_clip_id: Scalars['Int'];
  playlist_hash_key: Scalars['String'];
  user_playlist_clip_id: Scalars['Int'];
  user_playlist_collection_id?: Maybe<Scalars['Int']>;
  user_playlist_id: Scalars['Int'];
};

export type MomentFromGameResponse = {
  __typename?: 'MomentFromGameResponse';
  collection_hash_key?: Maybe<Scalars['String']>;
  game_clip_id?: Maybe<Scalars['Int']>;
  playlist_clip_id?: Maybe<Scalars['Int']>;
  profile_hash_key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MomentSearchResponse = {
  __typename?: 'MomentSearchResponse';
  moments?: Maybe<Array<Maybe<Moment>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Create/Add a collection to a profile
   * user_playlist_id => The trace id profile you want to add a collection to
   * edit => attributes of the collection that you want to add
   * token => user token of the person preforming the add
   */
  addCollection: CollectionAddResponse;
  /**
   * Add a moment to a trace id collection
   * hash_key => hash key of the collection the moment will be added to
   * add => information about the moment to add with additional customization options
   * token => user token of the person preforming this operation
   */
  addCollectionItem: CollectionItemAddResponse;
  /** Add a phone number to a user */
  addPhoneNumber: EditResponse;
  /** Create a stripe checkout session */
  addStripeCheckoutSession: StripeSessionResponse;
  /** Create a stripe customer portal session */
  addStripeCustomerPortalSession: StripeSessionResponse;
  /** Registers survey answer for a client */
  addSurveyAnswer: EditResponse;
  /** Create an upload video request and return it */
  addUploadVideoRequest: UploadVideoRequest;
  /** Copy or move collection item from one collection to another */
  copyCollectionItem: EditResponse;
  /**
   * Demoify profile
   * demo_key => The demo key constant of the profile to mimic
   * token => user token of the person preforming the edit
   */
  demoifyProfile: EditResponse;
  /** Download all collection moments as one video */
  downloadCollectionVideo: EditResponse;
  /**
   * Edit properties of a collection
   * hash_key => hash key of the collection you want to edit
   * edit => attributes of the collection that you want to change
   * token => user token of the person preforming the edit
   */
  editCollection: EditResponse;
  /** Edit a collection item by changing its position or customizing it */
  editCollectionItem: EditResponse;
  /**
   * Edit profile information
   * hash_key => The key of the profile to edit
   * edit => attributes of the profile that you want to change
   * token => user token of the person preforming the edit
   */
  editProfile: EditResponse;
  /**
   * Register notification action like the message was read or action button was clicked
   * If the list of message ids is passed then all actions are applied to every message id
   */
  notificationAction: EditResponse;
  /** Send login code for a shadow user when user_id and email hash are supplied */
  sendLoginCodeForShadowUser: EditResponse;
  /**
   * Start transcoding uploaded video into HLS stream
   * Return upload request with the updated status set to 'transcoding'
   */
  transcodeUploadVideoRequest: UploadVideoRequest;
};


export type MutationAddCollectionArgs = {
  edit: CollectionEdit;
  token: UserToken;
  user_playlist_id: Scalars['Int'];
};


export type MutationAddCollectionItemArgs = {
  add: CollectionItemAdd;
  hash_key: Scalars['String'];
  token: UserToken;
};


export type MutationAddPhoneNumberArgs = {
  phone_number: Scalars['String'];
  token: UserToken;
  user_id?: Maybe<Scalars['Int']>;
};


export type MutationAddStripeCheckoutSessionArgs = {
  cancel_url: Scalars['String'];
  price_id: Scalars['String'];
  profile_hash_key: Scalars['String'];
  success_url: Scalars['String'];
  token: UserToken;
};


export type MutationAddStripeCustomerPortalSessionArgs = {
  return_url: Scalars['String'];
  token: UserToken;
};


export type MutationAddSurveyAnswerArgs = {
  answer_id?: Maybe<Scalars['Int']>;
  app_name: Scalars['String'];
  client_id: Scalars['String'];
  survey_rule_id: Scalars['Int'];
  team_id?: Maybe<Scalars['Int']>;
  token?: Maybe<UserToken>;
};


export type MutationAddUploadVideoRequestArgs = {
  collection_hash_key: Scalars['String'];
  content_type: Scalars['String'];
  file_name: Scalars['String'];
  token: UserToken;
  user_playlist_id: Scalars['Int'];
};


export type MutationCopyCollectionItemArgs = {
  collection_hash_key: Scalars['String'];
  move: Scalars['Boolean'];
  to_collection_hash_key: Scalars['String'];
  token: UserToken;
  user_playlist_clip_id: Scalars['Int'];
};


export type MutationDemoifyProfileArgs = {
  demo_key: Scalars['String'];
  token?: Maybe<UserToken>;
};


export type MutationDownloadCollectionVideoArgs = {
  collection_hash_key?: Maybe<Scalars['String']>;
  token: UserToken;
};


export type MutationEditCollectionArgs = {
  edit: CollectionEdit;
  hash_key: Scalars['String'];
  token: UserToken;
};


export type MutationEditCollectionItemArgs = {
  collection_hash_key: Scalars['String'];
  edit: CollectionItemEdit;
  token: UserToken;
  user_playlist_clip_id: Scalars['Int'];
};


export type MutationEditProfileArgs = {
  edit: ProfileEdit;
  hash_key: Scalars['String'];
  token?: Maybe<UserToken>;
};


export type MutationNotificationActionArgs = {
  actions: Array<Maybe<NotificationAction>>;
  message_ids: Array<Maybe<Scalars['Int']>>;
  token: UserToken;
};


export type MutationSendLoginCodeForShadowUserArgs = {
  auth_url: Scalars['String'];
  email_hash: Scalars['String'];
  proceed_url: Scalars['String'];
  user_id: Scalars['Int'];
};


export type MutationTranscodeUploadVideoRequestArgs = {
  token: UserToken;
  upload_video_request_id: Scalars['Int'];
};

export type NotificationAction = {
  action_date: Scalars['DateTime'];
  action_type: Scalars['String'];
  delivery_id?: Maybe<Scalars['Int']>;
};

export type NotificationDelivery = {
  __typename?: 'NotificationDelivery';
  date_action?: Maybe<Scalars['DateTime']>;
  date_delivered?: Maybe<Scalars['DateTime']>;
  date_read?: Maybe<Scalars['DateTime']>;
  date_sent?: Maybe<Scalars['DateTime']>;
  delivery_id?: Maybe<Scalars['Int']>;
  ext_user_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  delivery?: Maybe<NotificationDelivery>;
  message?: Maybe<Scalars['JSON']>;
  msg_date?: Maybe<Scalars['DateTime']>;
  msg_id: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

/**
 * Profile is a Trace iD profile
 * maps to 'user_playlists' table
 */
export type Profile = {
  __typename?: 'Profile';
  collections?: Maybe<Array<Maybe<Collection>>>;
  color?: Maybe<Scalars['Int']>;
  contact?: Maybe<Scalars['String']>;
  content_access?: Maybe<Scalars['String']>;
  creation_time?: Maybe<Scalars['DateTime']>;
  demo_key?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  games?: Maybe<Array<Maybe<Game>>>;
  gpa?: Maybe<Scalars['String']>;
  grad_year?: Maybe<Scalars['String']>;
  hash_key?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<ProfilePermission>;
  positions?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  test_score?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  update_time?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['Int']>;
  user_playlist_id?: Maybe<Scalars['Int']>;
  view_count?: Maybe<Scalars['Int']>;
  welcome_complete?: Maybe<Scalars['Boolean']>;
  wizard_count?: Maybe<Scalars['Int']>;
  wizard_step?: Maybe<Scalars['String']>;
};

/** All fields you can edit in a Profile object */
export type ProfileEdit = {
  contact?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['String']>;
  grad_year?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  positions?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  test_score?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  welcome_complete?: Maybe<Scalars['Boolean']>;
  wizard_count?: Maybe<Scalars['Int']>;
  wizard_step?: Maybe<Scalars['String']>;
};

/** Profile Permissions */
export type ProfilePermission = {
  __typename?: 'ProfilePermission';
  archive: Scalars['Boolean'];
  collections_limit: Scalars['Int'];
  create: Scalars['Boolean'];
  edit: Scalars['Boolean'];
  family_access: Scalars['Boolean'];
  payments: Scalars['Boolean'];
  plan_type: Scalars['String'];
  view: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  /** Find a single collection */
  collection?: Maybe<Collection>;
  /** Find a collections for a playlist */
  collections?: Maybe<Array<Maybe<Collection>>>;
  /** Find content access for a Team */
  contentAccessForTeam?: Maybe<ContentAccess>;
  /** Find content access for a user */
  contentAccessForUser?: Maybe<ContentAccess>;
  /** Find content access for a user Id */
  contentAccessForUserId?: Maybe<ContentAccess>;
  /** Return a full game video moment covering the given moment */
  fullVideoByMoment?: Maybe<Moment>;
  /** Return a full game video moment covering the given collection item moment */
  fullVideoMoment?: Maybe<Moment>;
  /** Return a full game video moment for the given game id */
  fullVideoMomentsByGame?: Maybe<Array<Maybe<Moment>>>;
  /** Find games by user id or game id */
  game?: Maybe<Game>;
  /** Fins and return a list of latest notifications for the logged in user or anonymous one */
  latestNotifications: Array<Maybe<NotificationMessage>>;
  /** Find a moment by id */
  moment?: Maybe<Moment>;
  /** Return collection and profile info for the given moment */
  momentCollectionInfo: Array<Maybe<MomentCollectionInfo>>;
  momentCollectionsByUserAndGame?: Maybe<Array<Maybe<MomentFromGameResponse>>>;
  /**
   * Return a list of moments for a given tag names
   * Should always specify at least one 'player-NNNN' tag
   */
  momentTagsSearch: MomentSearchResponse;
  /**
   * Return a list of moments for a user_id/hash_key and given tag names
   * Should always specify at least one 'player-NNNN' tag
   */
  myMoments: MomentSearchResponse;
  /** Find a profile with some kind of id */
  profile?: Maybe<Profile>;
  /** Get surveys for a client */
  surveys: Array<Maybe<Survey>>;
  /** Find upload video request by id */
  uploadVideoRequest?: Maybe<UploadVideoRequest>;
  /** Find informatin about a user */
  user?: Maybe<User>;
  /** Find information about a user */
  userNames?: Maybe<UserNames>;
  /** Return all user relations to the to_user_id */
  userRelations?: Maybe<Array<Maybe<UserRelation>>>;
  /** Find the role for a user */
  userRole?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryCollectionArgs = {
  hash_key?: Maybe<Scalars['String']>;
  token: UserToken;
};


export type QueryCollectionsArgs = {
  token: UserToken;
  user_id?: Maybe<Scalars['Int']>;
  user_playlist_id?: Maybe<Scalars['Int']>;
};


export type QueryContentAccessForTeamArgs = {
  game_id?: Maybe<Scalars['Int']>;
  team_id: Scalars['Int'];
  token: UserToken;
};


export type QueryContentAccessForUserArgs = {
  team_id: Scalars['Int'];
  token: UserToken;
};


export type QueryContentAccessForUserIdArgs = {
  token: UserToken;
  user_id: Scalars['Int'];
};


export type QueryFullVideoByMomentArgs = {
  game_clip_id: Scalars['Int'];
  token: UserToken;
};


export type QueryFullVideoMomentArgs = {
  collection_hash_key: Scalars['String'];
  token: UserToken;
  user_playlist_clip_id: Scalars['Int'];
};


export type QueryFullVideoMomentsByGameArgs = {
  game_id: Scalars['Int'];
};


export type QueryGameArgs = {
  game_id: Scalars['Int'];
};


export type QueryLatestNotificationsArgs = {
  external_user_id?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<FilterValue>>>;
  token?: Maybe<UserToken>;
};


export type QueryMomentArgs = {
  moment_id: Scalars['Int'];
  team_name: Scalars['String'];
  user_id: Scalars['Int'];
};


export type QueryMomentCollectionInfoArgs = {
  game_clip_id: Scalars['Int'];
  token: UserToken;
  user_id: Scalars['Int'];
};


export type QueryMomentCollectionsByUserAndGameArgs = {
  game_id: Scalars['Int'];
  token: UserToken;
  user_id: Scalars['Int'];
};


export type QueryMomentTagsSearchArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  tags: Array<Maybe<Scalars['String']>>;
  token: UserToken;
};


export type QueryMyMomentsArgs = {
  hash_key?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  tags: Array<Maybe<Scalars['String']>>;
  token: UserToken;
  user_id?: Maybe<Scalars['Int']>;
};


export type QueryProfileArgs = {
  hash_key?: Maybe<Scalars['String']>;
  token: UserToken;
  user_id?: Maybe<Scalars['Int']>;
  user_playlist_id?: Maybe<Scalars['Int']>;
};


export type QuerySurveysArgs = {
  client_id: Scalars['String'];
  team_id?: Maybe<Scalars['Int']>;
  token?: Maybe<UserToken>;
};


export type QueryUploadVideoRequestArgs = {
  token: UserToken;
  upload_video_request_id: Scalars['Int'];
};


export type QueryUserArgs = {
  token: UserToken;
  user_id?: Maybe<Scalars['Int']>;
};


export type QueryUserNamesArgs = {
  email_hash: Scalars['String'];
  user_id: Scalars['Int'];
};


export type QueryUserRelationsArgs = {
  include_self?: Maybe<Scalars['Boolean']>;
  to_user_id: Scalars['Int'];
  token: UserToken;
};


export type QueryUserRoleArgs = {
  division_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  token: UserToken;
};

/**
 * A spotlight is a time and location that can be used to apply different effects in a video
 * maps to 'game_clips.meta.spotlights'
 */
export type Spotlight = {
  __typename?: 'Spotlight';
  center?: Maybe<Array<Maybe<Scalars['Float']>>>;
  corr?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  trace_number?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  utc?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** All fields need to create or edit a spotlight */
export type SpotlightEdit = {
  center?: Maybe<Array<Maybe<Scalars['Float']>>>;
  corr?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  trace_number?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
  utc?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** StripeSessionResponse contains URL for accessing Stripe hosted page associated with the new session */
export type StripeSessionResponse = {
  __typename?: 'StripeSessionResponse';
  error: Scalars['String'];
  session_url?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Survey information with question and possible answers */
export type Survey = {
  __typename?: 'Survey';
  answers: Array<Maybe<SurveyDetail>>;
  question: Scalars['String'];
  rule_id: Scalars['Int'];
  settings?: Maybe<Scalars['JSON']>;
};

/** SurveyDetail information */
export type SurveyDetail = {
  __typename?: 'SurveyDetail';
  detail_id: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Tags for moments
 * maps to 'game_clip_taggings', 'game_clip_tags'
 */
export type Tag = {
  __typename?: 'Tag';
  category?: Maybe<Scalars['String']>;
  game_clip_tag_id?: Maybe<Scalars['Int']>;
  game_clip_tagging_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * Tag structure to pass info about tags
 * One should pass either name or id
 */
export type TagAdd = {
  game_clip_tag_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * A soccer team
 * maps to 'teams'
 */
export type Team = {
  __typename?: 'Team';
  abbr?: Maybe<Scalars['String']>;
  created_user_id?: Maybe<Scalars['Int']>;
  creation_time?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  players_birth_year?: Maybe<Scalars['Int']>;
  players_gender?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  update_time?: Maybe<Scalars['DateTime']>;
};

/**
 * Information about a team for a specific Moment same as team but includes color and score
 * maps to 'game_clips.meta.home_team'
 */
export type TeamInfo = {
  __typename?: 'TeamInfo';
  abbr?: Maybe<Scalars['String']>;
  club_id?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  content_access?: Maybe<Scalars['String']>;
  created_user_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  players_birth_year?: Maybe<Scalars['Int']>;
  players_gender?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * =======
 * Upload video requests
 * Create this one when we start uploading video from the client
 */
export type UploadVideoRequest = {
  __typename?: 'UploadVideoRequest';
  content_type?: Maybe<Scalars['String']>;
  dest_alias?: Maybe<Scalars['String']>;
  dest_key?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  game_clip_id?: Maybe<Scalars['Int']>;
  ref_id?: Maybe<Scalars['Int']>;
  ref_type?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  step?: Maybe<Scalars['Int']>;
  upload_key?: Maybe<Scalars['String']>;
  upload_url?: Maybe<Scalars['String']>;
  upload_video_request_id: Scalars['Int'];
  user_playlist_clip_id?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_width?: Maybe<Scalars['Int']>;
};

/**
 * Trace user accounts
 * maps to 'users' table
 */
export type User = {
  __typename?: 'User';
  acl?: Maybe<AclOptions>;
  divisions?: Maybe<Array<Maybe<Division>>>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  has_subscription?: Maybe<Scalars['Boolean']>;
  image_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  masked_email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  recent_division_id?: Maybe<Scalars['Int']>;
  recent_games?: Maybe<Array<Maybe<Game>>>;
  trace_id_plan_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/**
 * Trace user info
 * from 'users' table
 */
export type UserNames = {
  __typename?: 'UserNames';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UserRelation = {
  __typename?: 'UserRelation';
  relation: Scalars['String'];
  user?: Maybe<User>;
  user_id: Scalars['Int'];
};

/** User auth tokens */
export type UserToken = {
  shadow_hash?: Maybe<Scalars['String']>;
  shadow_user_id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type AddCollectionMutationVariables = Exact<{
  user_playlist_id: Scalars['Int'];
  edit: CollectionEdit;
  token: UserToken;
}>;


export type AddCollectionMutation = { __typename?: 'Mutation', addCollection: { __typename?: 'CollectionAddResponse', success: boolean, error: string, hash_key?: Maybe<string> } };

export type AddCollectionItemMutationVariables = Exact<{
  hash_key: Scalars['String'];
  add: CollectionItemAdd;
  token: UserToken;
}>;


export type AddCollectionItemMutation = { __typename?: 'Mutation', addCollectionItem: { __typename?: 'CollectionItemAddResponse', success: boolean, error: string, user_playlist_clip_id?: Maybe<number> } };

export type AddMemberPhoneNumberMutationVariables = Exact<{
  token: UserToken;
  phoneNumber: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type AddMemberPhoneNumberMutation = { __typename?: 'Mutation', addPhoneNumber: { __typename?: 'EditResponse', success: boolean, error: string } };

export type AddPhoneNumberMutationVariables = Exact<{
  token: UserToken;
  phoneNumber: Scalars['String'];
}>;


export type AddPhoneNumberMutation = { __typename?: 'Mutation', addPhoneNumber: { __typename?: 'EditResponse', success: boolean, error: string } };

export type AddStripeCheckoutSessionMutationVariables = Exact<{
  token: UserToken;
  profile_hash_key: Scalars['String'];
  price_id: Scalars['String'];
  success_url: Scalars['String'];
  cancel_url: Scalars['String'];
}>;


export type AddStripeCheckoutSessionMutation = { __typename?: 'Mutation', addStripeCheckoutSession: { __typename?: 'StripeSessionResponse', session_url?: Maybe<string>, success: boolean, error: string } };

export type AddSurveyAnswerMutationVariables = Exact<{
  client_id: Scalars['String'];
  token: UserToken;
  team_id?: Maybe<Scalars['Int']>;
  survey_rule_id: Scalars['Int'];
  answer_id?: Maybe<Scalars['Int']>;
  app_name: Scalars['String'];
}>;


export type AddSurveyAnswerMutation = { __typename?: 'Mutation', addSurveyAnswer: { __typename?: 'EditResponse', success: boolean, error: string } };

export type CollectionQueryVariables = Exact<{
  hash_key: Scalars['String'];
  token: UserToken;
}>;


export type CollectionQuery = { __typename?: 'Query', collection?: Maybe<{ __typename?: 'Collection', user_playlist_collection_id?: Maybe<number>, user_playlist_id?: Maybe<number>, hash_key: string, title: string, public: boolean, archived: boolean, position?: Maybe<number>, color?: Maybe<number>, creation_time?: Maybe<any>, update_time?: Maybe<any>, locked?: Maybe<boolean>, view_count?: Maybe<number>, permission?: Maybe<{ __typename?: 'CollectionPermission', view: boolean, list: boolean, edit: boolean, archive: boolean, items_copy: boolean, items_move: boolean, items_archive: boolean, collection_items_limit: number, items_reorder: boolean, upload_video: boolean, download_video: boolean }>, items?: Maybe<Array<Maybe<{ __typename?: 'CollectionItem', user_playlist_clip_id?: Maybe<number>, position?: Maybe<number>, locked?: Maybe<boolean>, moment?: Maybe<{ __typename?: 'Moment', parent_ref_id?: Maybe<number>, game_clip_id?: Maybe<number>, game_id?: Maybe<number>, team_id?: Maybe<number>, start_time?: Maybe<number>, duration?: Maybe<number>, half?: Maybe<number>, time?: Maybe<number>, title?: Maybe<string>, type?: Maybe<string>, start_third?: Maybe<string>, end_third?: Maybe<string>, dynamic_audio?: Maybe<string>, dynamic_duration?: Maybe<number>, dynamic_hls?: Maybe<string>, dynamic_jfile?: Maybe<string>, dynamic_offset?: Maybe<number>, dynamic_start?: Maybe<number>, sport_type?: Maybe<string>, keywords?: Maybe<Array<Maybe<string>>>, thirds?: Maybe<Array<Maybe<string>>>, trace_numbers?: Maybe<Array<Maybe<string>>>, base_path?: Maybe<string>, home_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, score?: Maybe<number>, color?: Maybe<string> }>, away_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, score?: Maybe<number>, color?: Maybe<string> }>, spotlights?: Maybe<Array<Maybe<{ __typename?: 'Spotlight', center?: Maybe<Array<Maybe<number>>>, corr?: Maybe<number>, height?: Maybe<number>, trace_number?: Maybe<string>, user_id?: Maybe<number>, utc?: Maybe<number>, width?: Maybe<number> }>>>, tags?: Maybe<Array<Maybe<{ __typename?: 'Tag', game_clip_tagging_id?: Maybe<number>, game_clip_tag_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string> }>>> }> }>>> }> };

export type CollectionsQueryVariables = Exact<{
  user_id?: Maybe<Scalars['Int']>;
  token: UserToken;
  user_playlist_id?: Maybe<Scalars['Int']>;
}>;


export type CollectionsQuery = { __typename?: 'Query', collections?: Maybe<Array<Maybe<{ __typename?: 'Collection', hash_key: string, title: string, public: boolean }>>> };

export type ContentAccessForTeamQueryVariables = Exact<{
  team_id: Scalars['Int'];
  token: UserToken;
  game_id?: Maybe<Scalars['Int']>;
}>;


export type ContentAccessForTeamQuery = { __typename?: 'Query', contentAccessForTeam?: Maybe<{ __typename?: 'ContentAccess', action?: Maybe<string>, allowed?: Maybe<boolean> }> };

export type GetDehydratedUserQueryVariables = Exact<{
  user_id: Scalars['Int'];
  token: UserToken;
}>;


export type GetDehydratedUserQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', user_id?: Maybe<number>, first_name?: Maybe<string>, last_name?: Maybe<string> }> };

export type EditCollectionItemMutationVariables = Exact<{
  collection_hash_key: Scalars['String'];
  user_playlist_clip_id: Scalars['Int'];
  edit: CollectionItemEdit;
  token: UserToken;
}>;


export type EditCollectionItemMutation = { __typename?: 'Mutation', editCollectionItem: { __typename?: 'EditResponse', success: boolean, error: string } };

export type FindProfileQueryVariables = Exact<{
  user_id: Scalars['Int'];
  token: UserToken;
}>;


export type FindProfileQuery = { __typename?: 'Query', profile?: Maybe<{ __typename?: 'Profile', user_playlist_id?: Maybe<number>, user_id?: Maybe<number>, hash_key?: Maybe<string>, name?: Maybe<string>, image_url?: Maybe<string>, collections?: Maybe<Array<Maybe<{ __typename?: 'Collection', user_playlist_id?: Maybe<number>, hash_key: string, title: string, color?: Maybe<number>, public: boolean, creation_time?: Maybe<any>, items?: Maybe<Array<Maybe<{ __typename?: 'CollectionItem', user_playlist_clip_id?: Maybe<number>, user_playlist_id?: Maybe<number>, user_playlist_collection_id?: Maybe<number>, clip_id?: Maybe<number> }>>> }>>>, permission?: Maybe<{ __typename?: 'ProfilePermission', create: boolean, plan_type: string, collections_limit: number }> }> };

export type FindProfileByUserIdQueryVariables = Exact<{
  user_id: Scalars['Int'];
  token: UserToken;
}>;


export type FindProfileByUserIdQuery = { __typename?: 'Query', profile?: Maybe<{ __typename?: 'Profile', user_playlist_id?: Maybe<number>, user_id?: Maybe<number>, name?: Maybe<string>, hash_key?: Maybe<string>, image_url?: Maybe<string>, contact?: Maybe<string>, sport?: Maybe<string>, wizard_step?: Maybe<string>, wizard_count?: Maybe<number>, collections?: Maybe<Array<Maybe<{ __typename?: 'Collection', user_playlist_id?: Maybe<number>, hash_key: string, title: string, public: boolean, color?: Maybe<number>, items?: Maybe<Array<Maybe<{ __typename?: 'CollectionItem', user_playlist_clip_id?: Maybe<number>, user_playlist_id?: Maybe<number>, user_playlist_collection_id?: Maybe<number>, clip_id?: Maybe<number> }>>> }>>>, permission?: Maybe<{ __typename?: 'ProfilePermission', create: boolean, plan_type: string, collections_limit: number }> }> };

export type FullVideoByMomentQueryVariables = Exact<{
  game_clip_id: Scalars['Int'];
  token: UserToken;
}>;


export type FullVideoByMomentQuery = { __typename?: 'Query', fullVideoByMoment?: Maybe<{ __typename?: 'Moment', game_clip_id?: Maybe<number>, game_id?: Maybe<number>, team_id?: Maybe<number>, start_time?: Maybe<number>, base_path?: Maybe<string>, duration?: Maybe<number>, half?: Maybe<number>, time?: Maybe<number>, title?: Maybe<string>, type?: Maybe<string>, start_third?: Maybe<string>, end_third?: Maybe<string>, dynamic_audio?: Maybe<string>, dynamic_duration?: Maybe<number>, dynamic_hls?: Maybe<string>, dynamic_jfile?: Maybe<string>, dynamic_offset?: Maybe<number>, dynamic_start?: Maybe<number>, sport_type?: Maybe<string>, keywords?: Maybe<Array<Maybe<string>>>, thirds?: Maybe<Array<Maybe<string>>>, trace_numbers?: Maybe<Array<Maybe<string>>>, parent_ref_id?: Maybe<number>, parent_col_id?: Maybe<number>, home_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, club_id?: Maybe<number>, created_user_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, players_gender?: Maybe<string>, players_birth_year?: Maybe<number>, color?: Maybe<string>, score?: Maybe<number> }>, away_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, club_id?: Maybe<number>, created_user_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, players_gender?: Maybe<string>, players_birth_year?: Maybe<number>, color?: Maybe<string>, score?: Maybe<number> }>, spotlights?: Maybe<Array<Maybe<{ __typename?: 'Spotlight', center?: Maybe<Array<Maybe<number>>>, corr?: Maybe<number>, height?: Maybe<number>, trace_number?: Maybe<string>, user_id?: Maybe<number>, utc?: Maybe<number>, width?: Maybe<number> }>>>, tags?: Maybe<Array<Maybe<{ __typename?: 'Tag', game_clip_tagging_id?: Maybe<number>, game_clip_tag_id?: Maybe<number>, name?: Maybe<string>, category?: Maybe<string>, title?: Maybe<string> }>>> }> };

export type FullVideoMomentQueryVariables = Exact<{
  collection_hash_key: Scalars['String'];
  user_playlist_clip_id: Scalars['Int'];
  token: UserToken;
}>;


export type FullVideoMomentQuery = { __typename?: 'Query', fullVideoMoment?: Maybe<{ __typename?: 'Moment', game_clip_id?: Maybe<number>, game_id?: Maybe<number>, team_id?: Maybe<number>, start_time?: Maybe<number>, base_path?: Maybe<string>, duration?: Maybe<number>, half?: Maybe<number>, time?: Maybe<number>, type?: Maybe<string>, dynamic_audio?: Maybe<string>, dynamic_duration?: Maybe<number>, dynamic_hls?: Maybe<string>, dynamic_jfile?: Maybe<string>, dynamic_offset?: Maybe<number>, dynamic_start?: Maybe<number>, sport_type?: Maybe<string> }> };

export type LatestNotificationsQueryVariables = Exact<{
  token: UserToken;
}>;


export type LatestNotificationsQuery = { __typename?: 'Query', latestNotifications: Array<Maybe<{ __typename?: 'NotificationMessage', msg_id: number, msg_date?: Maybe<any>, message?: Maybe<any>, type?: Maybe<string>, delivery?: Maybe<{ __typename?: 'NotificationDelivery', delivery_id?: Maybe<number>, user_id?: Maybe<number>, ext_user_id?: Maybe<string>, date_sent?: Maybe<any>, date_delivered?: Maybe<any>, date_read?: Maybe<any>, date_action?: Maybe<any> }> }>> };

export type MomentQueryVariables = Exact<{
  momentId: Scalars['Int'];
  userId: Scalars['Int'];
  teamName: Scalars['String'];
}>;


export type MomentQuery = { __typename?: 'Query', moment?: Maybe<{ __typename?: 'Moment', game_clip_id?: Maybe<number>, team_id?: Maybe<number>, game_id?: Maybe<number>, start_time?: Maybe<number>, base_path?: Maybe<string>, duration?: Maybe<number>, time?: Maybe<number>, type?: Maybe<string>, dynamic_duration?: Maybe<number>, dynamic_hls?: Maybe<string>, dynamic_jfile?: Maybe<string>, dynamic_offset?: Maybe<number>, dynamic_start?: Maybe<number>, parent_ref_id?: Maybe<number>, parent_col_id?: Maybe<number>, thirds?: Maybe<Array<Maybe<string>>>, keywords?: Maybe<Array<Maybe<string>>>, home_team?: Maybe<{ __typename?: 'TeamInfo', name?: Maybe<string>, abbr?: Maybe<string>, color?: Maybe<string>, score?: Maybe<number>, team_id?: Maybe<number> }>, tags?: Maybe<Array<Maybe<{ __typename?: 'Tag', game_clip_tagging_id?: Maybe<number>, game_clip_tag_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string> }>>>, away_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, title?: Maybe<string>, abbr?: Maybe<string>, score?: Maybe<number>, color?: Maybe<string> }> }> };

export type GetMomentCollectionInfoQueryVariables = Exact<{
  user_id: Scalars['Int'];
  game_clip_id: Scalars['Int'];
  token: UserToken;
}>;


export type GetMomentCollectionInfoQuery = { __typename?: 'Query', momentCollectionInfo: Array<Maybe<{ __typename?: 'MomentCollectionInfo', game_clip_id: number, user_playlist_clip_id: number, user_playlist_id: number, playlist_hash_key: string, user_playlist_collection_id?: Maybe<number>, collection_hash_key?: Maybe<string> }>> };

export type GetMomentCollectionsByUserAndGameQueryVariables = Exact<{
  user_id: Scalars['Int'];
  game_id: Scalars['Int'];
  token: UserToken;
}>;


export type GetMomentCollectionsByUserAndGameQuery = { __typename?: 'Query', momentCollectionsByUserAndGame?: Maybe<Array<Maybe<{ __typename?: 'MomentFromGameResponse', game_clip_id?: Maybe<number>, playlist_clip_id?: Maybe<number>, title?: Maybe<string>, collection_hash_key?: Maybe<string>, profile_hash_key?: Maybe<string> }>>> };

export type NotificationActionMutationVariables = Exact<{
  message_ids: Array<Maybe<Scalars['Int']>> | Maybe<Scalars['Int']>;
  actions: Array<Maybe<NotificationAction>> | Maybe<NotificationAction>;
  token: UserToken;
}>;


export type NotificationActionMutation = { __typename?: 'Mutation', notificationAction: { __typename?: 'EditResponse', success: boolean, error: string } };

export type ProfileQueryVariables = Exact<{
  hash_key: Scalars['String'];
  token: UserToken;
}>;


export type ProfileQuery = { __typename?: 'Query', profile?: Maybe<{ __typename?: 'Profile', user_playlist_id?: Maybe<number>, hash_key?: Maybe<string>, name?: Maybe<string>, user_id?: Maybe<number>, type?: Maybe<string>, description?: Maybe<string>, tagline?: Maybe<string>, image_url?: Maybe<string>, view_count?: Maybe<number>, contact?: Maybe<string>, test_score?: Maybe<string>, gpa?: Maybe<string>, grad_year?: Maybe<string>, positions?: Maybe<string>, facebook?: Maybe<string>, twitter?: Maybe<string>, instagram?: Maybe<string>, welcome_complete?: Maybe<boolean>, creation_time?: Maybe<any>, update_time?: Maybe<any>, permission?: Maybe<{ __typename?: 'ProfilePermission', view: boolean, edit: boolean, create: boolean, archive: boolean, plan_type: string, collections_limit: number, family_access: boolean }>, collections?: Maybe<Array<Maybe<{ __typename?: 'Collection', user_playlist_collection_id?: Maybe<number>, hash_key: string, title: string, public: boolean, archived: boolean, color?: Maybe<number>, position?: Maybe<number>, thumbnails?: Maybe<Array<Maybe<string>>>, creation_time?: Maybe<any>, update_time?: Maybe<any>, num_items?: Maybe<number>, locked?: Maybe<boolean>, permission?: Maybe<{ __typename?: 'CollectionPermission', view: boolean, list: boolean, edit: boolean, archive: boolean, items_copy: boolean, items_move: boolean, items_archive: boolean, collection_items_limit: number }> }>>> }> };

export type SendLoginCodeForShadowUserMutationVariables = Exact<{
  user_id: Scalars['Int'];
  email_hash: Scalars['String'];
  proceed_url: Scalars['String'];
  auth_url: Scalars['String'];
}>;


export type SendLoginCodeForShadowUserMutation = { __typename?: 'Mutation', sendLoginCodeForShadowUser: { __typename?: 'EditResponse', success: boolean, error: string } };

export type SurveysQueryVariables = Exact<{
  client_id: Scalars['String'];
  token: UserToken;
  team_id?: Maybe<Scalars['Int']>;
}>;


export type SurveysQuery = { __typename?: 'Query', surveys: Array<Maybe<{ __typename?: 'Survey', rule_id: number, question: string, settings?: Maybe<any>, answers: Array<Maybe<{ __typename?: 'SurveyDetail', detail_id: number, title: string }>> }>> };

export type GetUserQueryVariables = Exact<{
  user_id: Scalars['Int'];
  token: UserToken;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', user_id?: Maybe<number>, name?: Maybe<string>, email?: Maybe<string>, first_name?: Maybe<string>, last_name?: Maybe<string>, has_subscription?: Maybe<boolean>, acl?: Maybe<{ __typename?: 'AclOptions', create_moment_tool?: Maybe<boolean>, traceid_v2?: Maybe<boolean> }>, recent_games?: Maybe<Array<Maybe<{ __typename?: 'Game', game_id: number, full_date?: Maybe<any>, approx_half_duration?: Maybe<number>, home_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, created_user_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, players_gender?: Maybe<string>, players_birth_year?: Maybe<number>, score?: Maybe<number>, content_access?: Maybe<string> }>, away_team?: Maybe<{ __typename?: 'TeamInfo', team_id?: Maybe<number>, created_user_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, players_gender?: Maybe<string>, players_birth_year?: Maybe<number>, score?: Maybe<number>, content_access?: Maybe<string> }> }>>>, divisions?: Maybe<Array<Maybe<{ __typename?: 'Division', division_id?: Maybe<number>, is_member?: Maybe<boolean>, title?: Maybe<string>, type?: Maybe<string>, teams?: Maybe<Array<Maybe<{ __typename?: 'Team', team_id?: Maybe<number>, created_user_id?: Maybe<number>, name?: Maybe<string>, title?: Maybe<string>, abbr?: Maybe<string>, players_gender?: Maybe<string>, players_birth_year?: Maybe<number>, creation_time?: Maybe<any>, update_time?: Maybe<any> }>>> }>>> }> };

export type GetUserDivisionQueryVariables = Exact<{
  user_id: Scalars['Int'];
  token: UserToken;
}>;


export type GetUserDivisionQuery = { __typename?: 'Query', user?: Maybe<{ __typename?: 'User', user_id?: Maybe<number>, email?: Maybe<string>, recent_division_id?: Maybe<number> }> };

export type GetUserNamesQueryVariables = Exact<{
  user_id: Scalars['Int'];
  email_hash: Scalars['String'];
}>;


export type GetUserNamesQuery = { __typename?: 'Query', userNames?: Maybe<{ __typename?: 'UserNames', first_name?: Maybe<string>, last_name?: Maybe<string>, email?: Maybe<string>, name?: Maybe<string> }> };

export type GetUserRelationsQueryVariables = Exact<{
  to_user_id: Scalars['Int'];
  token: UserToken;
  include_self?: Maybe<Scalars['Boolean']>;
}>;


export type GetUserRelationsQuery = { __typename?: 'Query', userRelations?: Maybe<Array<Maybe<{ __typename?: 'UserRelation', user_id: number, relation: string, user?: Maybe<{ __typename?: 'User', image_url?: Maybe<string>, masked_email?: Maybe<string>, email?: Maybe<string>, first_name?: Maybe<string>, last_name?: Maybe<string>, user_id?: Maybe<number> }> }>>> };

export type UserRoleQueryVariables = Exact<{
  token: UserToken;
}>;


export type UserRoleQuery = { __typename?: 'Query', userRole?: Maybe<Array<Maybe<string>>> };


export const AddCollectionDocument = gql`
    mutation addCollection($user_playlist_id: Int!, $edit: CollectionEdit!, $token: UserToken!) {
  addCollection(user_playlist_id: $user_playlist_id, edit: $edit, token: $token) {
    success
    error
    hash_key
  }
}
    `;
export type AddCollectionMutationFn = Apollo.MutationFunction<AddCollectionMutation, AddCollectionMutationVariables>;

/**
 * __useAddCollectionMutation__
 *
 * To run a mutation, you first call `useAddCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCollectionMutation, { data, loading, error }] = useAddCollectionMutation({
 *   variables: {
 *      user_playlist_id: // value for 'user_playlist_id'
 *      edit: // value for 'edit'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAddCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddCollectionMutation, AddCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCollectionMutation, AddCollectionMutationVariables>(AddCollectionDocument, options);
      }
export type AddCollectionMutationHookResult = ReturnType<typeof useAddCollectionMutation>;
export type AddCollectionMutationResult = Apollo.MutationResult<AddCollectionMutation>;
export type AddCollectionMutationOptions = Apollo.BaseMutationOptions<AddCollectionMutation, AddCollectionMutationVariables>;
export const AddCollectionItemDocument = gql`
    mutation addCollectionItem($hash_key: String!, $add: CollectionItemAdd!, $token: UserToken!) {
  addCollectionItem(hash_key: $hash_key, add: $add, token: $token) {
    success
    error
    user_playlist_clip_id
  }
}
    `;
export type AddCollectionItemMutationFn = Apollo.MutationFunction<AddCollectionItemMutation, AddCollectionItemMutationVariables>;

/**
 * __useAddCollectionItemMutation__
 *
 * To run a mutation, you first call `useAddCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCollectionItemMutation, { data, loading, error }] = useAddCollectionItemMutation({
 *   variables: {
 *      hash_key: // value for 'hash_key'
 *      add: // value for 'add'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAddCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<AddCollectionItemMutation, AddCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCollectionItemMutation, AddCollectionItemMutationVariables>(AddCollectionItemDocument, options);
      }
export type AddCollectionItemMutationHookResult = ReturnType<typeof useAddCollectionItemMutation>;
export type AddCollectionItemMutationResult = Apollo.MutationResult<AddCollectionItemMutation>;
export type AddCollectionItemMutationOptions = Apollo.BaseMutationOptions<AddCollectionItemMutation, AddCollectionItemMutationVariables>;
export const AddMemberPhoneNumberDocument = gql`
    mutation addMemberPhoneNumber($token: UserToken!, $phoneNumber: String!, $userId: Int!) {
  addPhoneNumber(phone_number: $phoneNumber, token: $token, user_id: $userId) {
    success
    error
  }
}
    `;
export type AddMemberPhoneNumberMutationFn = Apollo.MutationFunction<AddMemberPhoneNumberMutation, AddMemberPhoneNumberMutationVariables>;

/**
 * __useAddMemberPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddMemberPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberPhoneNumberMutation, { data, loading, error }] = useAddMemberPhoneNumberMutation({
 *   variables: {
 *      token: // value for 'token'
 *      phoneNumber: // value for 'phoneNumber'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddMemberPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberPhoneNumberMutation, AddMemberPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberPhoneNumberMutation, AddMemberPhoneNumberMutationVariables>(AddMemberPhoneNumberDocument, options);
      }
export type AddMemberPhoneNumberMutationHookResult = ReturnType<typeof useAddMemberPhoneNumberMutation>;
export type AddMemberPhoneNumberMutationResult = Apollo.MutationResult<AddMemberPhoneNumberMutation>;
export type AddMemberPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AddMemberPhoneNumberMutation, AddMemberPhoneNumberMutationVariables>;
export const AddPhoneNumberDocument = gql`
    mutation addPhoneNumber($token: UserToken!, $phoneNumber: String!) {
  addPhoneNumber(phone_number: $phoneNumber, token: $token) {
    success
    error
  }
}
    `;
export type AddPhoneNumberMutationFn = Apollo.MutationFunction<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>;

/**
 * __useAddPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPhoneNumberMutation, { data, loading, error }] = useAddPhoneNumberMutation({
 *   variables: {
 *      token: // value for 'token'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useAddPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>(AddPhoneNumberDocument, options);
      }
export type AddPhoneNumberMutationHookResult = ReturnType<typeof useAddPhoneNumberMutation>;
export type AddPhoneNumberMutationResult = Apollo.MutationResult<AddPhoneNumberMutation>;
export type AddPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AddPhoneNumberMutation, AddPhoneNumberMutationVariables>;
export const AddStripeCheckoutSessionDocument = gql`
    mutation addStripeCheckoutSession($token: UserToken!, $profile_hash_key: String!, $price_id: String!, $success_url: String!, $cancel_url: String!) {
  addStripeCheckoutSession(
    profile_hash_key: $profile_hash_key
    price_id: $price_id
    success_url: $success_url
    cancel_url: $cancel_url
    token: $token
  ) {
    session_url
    success
    error
  }
}
    `;
export type AddStripeCheckoutSessionMutationFn = Apollo.MutationFunction<AddStripeCheckoutSessionMutation, AddStripeCheckoutSessionMutationVariables>;

/**
 * __useAddStripeCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useAddStripeCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStripeCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStripeCheckoutSessionMutation, { data, loading, error }] = useAddStripeCheckoutSessionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      profile_hash_key: // value for 'profile_hash_key'
 *      price_id: // value for 'price_id'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *   },
 * });
 */
export function useAddStripeCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddStripeCheckoutSessionMutation, AddStripeCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStripeCheckoutSessionMutation, AddStripeCheckoutSessionMutationVariables>(AddStripeCheckoutSessionDocument, options);
      }
export type AddStripeCheckoutSessionMutationHookResult = ReturnType<typeof useAddStripeCheckoutSessionMutation>;
export type AddStripeCheckoutSessionMutationResult = Apollo.MutationResult<AddStripeCheckoutSessionMutation>;
export type AddStripeCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<AddStripeCheckoutSessionMutation, AddStripeCheckoutSessionMutationVariables>;
export const AddSurveyAnswerDocument = gql`
    mutation addSurveyAnswer($client_id: String!, $token: UserToken!, $team_id: Int, $survey_rule_id: Int!, $answer_id: Int, $app_name: String!) {
  addSurveyAnswer(
    client_id: $client_id
    token: $token
    team_id: $team_id
    survey_rule_id: $survey_rule_id
    answer_id: $answer_id
    app_name: $app_name
  ) {
    success
    error
  }
}
    `;
export type AddSurveyAnswerMutationFn = Apollo.MutationFunction<AddSurveyAnswerMutation, AddSurveyAnswerMutationVariables>;

/**
 * __useAddSurveyAnswerMutation__
 *
 * To run a mutation, you first call `useAddSurveyAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyAnswerMutation, { data, loading, error }] = useAddSurveyAnswerMutation({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      token: // value for 'token'
 *      team_id: // value for 'team_id'
 *      survey_rule_id: // value for 'survey_rule_id'
 *      answer_id: // value for 'answer_id'
 *      app_name: // value for 'app_name'
 *   },
 * });
 */
export function useAddSurveyAnswerMutation(baseOptions?: Apollo.MutationHookOptions<AddSurveyAnswerMutation, AddSurveyAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSurveyAnswerMutation, AddSurveyAnswerMutationVariables>(AddSurveyAnswerDocument, options);
      }
export type AddSurveyAnswerMutationHookResult = ReturnType<typeof useAddSurveyAnswerMutation>;
export type AddSurveyAnswerMutationResult = Apollo.MutationResult<AddSurveyAnswerMutation>;
export type AddSurveyAnswerMutationOptions = Apollo.BaseMutationOptions<AddSurveyAnswerMutation, AddSurveyAnswerMutationVariables>;
export const CollectionDocument = gql`
    query collection($hash_key: String!, $token: UserToken!) {
  collection(hash_key: $hash_key, token: $token) {
    user_playlist_collection_id
    user_playlist_id
    hash_key
    title
    public
    archived
    position
    color
    creation_time
    update_time
    locked
    view_count
    permission {
      view
      list
      edit
      archive
      items_copy
      items_move
      items_archive
      collection_items_limit
      items_reorder
      upload_video
      download_video
    }
    items {
      user_playlist_clip_id
      position
      locked
      moment {
        parent_ref_id
        game_clip_id
        game_id
        team_id
        start_time
        duration
        half
        time
        title
        type
        start_third
        end_third
        dynamic_audio
        dynamic_duration
        dynamic_hls
        dynamic_jfile
        dynamic_offset
        dynamic_start
        sport_type
        keywords
        thirds
        trace_numbers
        base_path
        home_team {
          team_id
          name
          title
          abbr
          score
          color
        }
        away_team {
          team_id
          name
          title
          abbr
          score
          color
        }
        spotlights {
          center
          corr
          height
          trace_number
          user_id
          utc
          width
        }
        tags {
          game_clip_tagging_id
          game_clip_tag_id
          name
          title
        }
      }
    }
  }
}
    `;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      hash_key: // value for 'hash_key'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCollectionQuery(baseOptions: Apollo.QueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
      }
export function useCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
        }
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<typeof useCollectionLazyQuery>;
export type CollectionQueryResult = Apollo.QueryResult<CollectionQuery, CollectionQueryVariables>;
export const CollectionsDocument = gql`
    query collections($user_id: Int, $token: UserToken!, $user_playlist_id: Int) {
  collections(
    user_id: $user_id
    token: $token
    user_playlist_id: $user_playlist_id
  ) {
    hash_key
    title
    public
  }
}
    `;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *      user_playlist_id: // value for 'user_playlist_id'
 *   },
 * });
 */
export function useCollectionsQuery(baseOptions: Apollo.QueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
      }
export function useCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<typeof useCollectionsLazyQuery>;
export type CollectionsQueryResult = Apollo.QueryResult<CollectionsQuery, CollectionsQueryVariables>;
export const ContentAccessForTeamDocument = gql`
    query contentAccessForTeam($team_id: Int!, $token: UserToken!, $game_id: Int) {
  contentAccessForTeam(team_id: $team_id, token: $token, game_id: $game_id) {
    action
    allowed
  }
}
    `;

/**
 * __useContentAccessForTeamQuery__
 *
 * To run a query within a React component, call `useContentAccessForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAccessForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAccessForTeamQuery({
 *   variables: {
 *      team_id: // value for 'team_id'
 *      token: // value for 'token'
 *      game_id: // value for 'game_id'
 *   },
 * });
 */
export function useContentAccessForTeamQuery(baseOptions: Apollo.QueryHookOptions<ContentAccessForTeamQuery, ContentAccessForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAccessForTeamQuery, ContentAccessForTeamQueryVariables>(ContentAccessForTeamDocument, options);
      }
export function useContentAccessForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAccessForTeamQuery, ContentAccessForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAccessForTeamQuery, ContentAccessForTeamQueryVariables>(ContentAccessForTeamDocument, options);
        }
export type ContentAccessForTeamQueryHookResult = ReturnType<typeof useContentAccessForTeamQuery>;
export type ContentAccessForTeamLazyQueryHookResult = ReturnType<typeof useContentAccessForTeamLazyQuery>;
export type ContentAccessForTeamQueryResult = Apollo.QueryResult<ContentAccessForTeamQuery, ContentAccessForTeamQueryVariables>;
export const GetDehydratedUserDocument = gql`
    query getDehydratedUser($user_id: Int!, $token: UserToken!) {
  user(user_id: $user_id, token: $token) {
    user_id
    first_name
    last_name
  }
}
    `;

/**
 * __useGetDehydratedUserQuery__
 *
 * To run a query within a React component, call `useGetDehydratedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDehydratedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDehydratedUserQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetDehydratedUserQuery(baseOptions: Apollo.QueryHookOptions<GetDehydratedUserQuery, GetDehydratedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDehydratedUserQuery, GetDehydratedUserQueryVariables>(GetDehydratedUserDocument, options);
      }
export function useGetDehydratedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDehydratedUserQuery, GetDehydratedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDehydratedUserQuery, GetDehydratedUserQueryVariables>(GetDehydratedUserDocument, options);
        }
export type GetDehydratedUserQueryHookResult = ReturnType<typeof useGetDehydratedUserQuery>;
export type GetDehydratedUserLazyQueryHookResult = ReturnType<typeof useGetDehydratedUserLazyQuery>;
export type GetDehydratedUserQueryResult = Apollo.QueryResult<GetDehydratedUserQuery, GetDehydratedUserQueryVariables>;
export const EditCollectionItemDocument = gql`
    mutation editCollectionItem($collection_hash_key: String!, $user_playlist_clip_id: Int!, $edit: CollectionItemEdit!, $token: UserToken!) {
  editCollectionItem(
    collection_hash_key: $collection_hash_key
    user_playlist_clip_id: $user_playlist_clip_id
    edit: $edit
    token: $token
  ) {
    success
    error
  }
}
    `;
export type EditCollectionItemMutationFn = Apollo.MutationFunction<EditCollectionItemMutation, EditCollectionItemMutationVariables>;

/**
 * __useEditCollectionItemMutation__
 *
 * To run a mutation, you first call `useEditCollectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCollectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollectionItemMutation, { data, loading, error }] = useEditCollectionItemMutation({
 *   variables: {
 *      collection_hash_key: // value for 'collection_hash_key'
 *      user_playlist_clip_id: // value for 'user_playlist_clip_id'
 *      edit: // value for 'edit'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEditCollectionItemMutation(baseOptions?: Apollo.MutationHookOptions<EditCollectionItemMutation, EditCollectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCollectionItemMutation, EditCollectionItemMutationVariables>(EditCollectionItemDocument, options);
      }
export type EditCollectionItemMutationHookResult = ReturnType<typeof useEditCollectionItemMutation>;
export type EditCollectionItemMutationResult = Apollo.MutationResult<EditCollectionItemMutation>;
export type EditCollectionItemMutationOptions = Apollo.BaseMutationOptions<EditCollectionItemMutation, EditCollectionItemMutationVariables>;
export const FindProfileDocument = gql`
    query findProfile($user_id: Int!, $token: UserToken!) {
  profile(user_id: $user_id, token: $token) {
    user_playlist_id
    user_id
    hash_key
    name
    image_url
    collections {
      user_playlist_id
      hash_key
      title
      color
      public
      color
      creation_time
      items {
        user_playlist_clip_id
        user_playlist_id
        user_playlist_collection_id
        clip_id
      }
    }
    permission {
      create
      plan_type
      collections_limit
    }
  }
}
    `;

/**
 * __useFindProfileQuery__
 *
 * To run a query within a React component, call `useFindProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProfileQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFindProfileQuery(baseOptions: Apollo.QueryHookOptions<FindProfileQuery, FindProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProfileQuery, FindProfileQueryVariables>(FindProfileDocument, options);
      }
export function useFindProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProfileQuery, FindProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProfileQuery, FindProfileQueryVariables>(FindProfileDocument, options);
        }
export type FindProfileQueryHookResult = ReturnType<typeof useFindProfileQuery>;
export type FindProfileLazyQueryHookResult = ReturnType<typeof useFindProfileLazyQuery>;
export type FindProfileQueryResult = Apollo.QueryResult<FindProfileQuery, FindProfileQueryVariables>;
export const FindProfileByUserIdDocument = gql`
    query findProfileByUserId($user_id: Int!, $token: UserToken!) {
  profile(user_id: $user_id, token: $token) {
    user_playlist_id
    user_id
    name
    hash_key
    image_url
    contact
    sport
    wizard_step
    wizard_count
    collections {
      user_playlist_id
      hash_key
      title
      public
      color
      items {
        user_playlist_clip_id
        user_playlist_id
        user_playlist_collection_id
        clip_id
      }
    }
    permission {
      create
      plan_type
      collections_limit
    }
  }
}
    `;

/**
 * __useFindProfileByUserIdQuery__
 *
 * To run a query within a React component, call `useFindProfileByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProfileByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProfileByUserIdQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFindProfileByUserIdQuery(baseOptions: Apollo.QueryHookOptions<FindProfileByUserIdQuery, FindProfileByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProfileByUserIdQuery, FindProfileByUserIdQueryVariables>(FindProfileByUserIdDocument, options);
      }
export function useFindProfileByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProfileByUserIdQuery, FindProfileByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProfileByUserIdQuery, FindProfileByUserIdQueryVariables>(FindProfileByUserIdDocument, options);
        }
export type FindProfileByUserIdQueryHookResult = ReturnType<typeof useFindProfileByUserIdQuery>;
export type FindProfileByUserIdLazyQueryHookResult = ReturnType<typeof useFindProfileByUserIdLazyQuery>;
export type FindProfileByUserIdQueryResult = Apollo.QueryResult<FindProfileByUserIdQuery, FindProfileByUserIdQueryVariables>;
export const FullVideoByMomentDocument = gql`
    query fullVideoByMoment($game_clip_id: Int!, $token: UserToken!) {
  fullVideoByMoment(game_clip_id: $game_clip_id, token: $token) {
    game_clip_id
    game_id
    team_id
    start_time
    base_path
    duration
    half
    time
    title
    type
    start_third
    end_third
    dynamic_audio
    dynamic_duration
    dynamic_hls
    dynamic_jfile
    dynamic_offset
    dynamic_start
    sport_type
    keywords
    thirds
    trace_numbers
    home_team {
      team_id
      club_id
      created_user_id
      name
      title
      abbr
      players_gender
      players_birth_year
      color
      score
    }
    away_team {
      team_id
      club_id
      created_user_id
      name
      title
      abbr
      players_gender
      players_birth_year
      color
      score
    }
    spotlights {
      center
      corr
      height
      trace_number
      user_id
      utc
      width
    }
    tags {
      game_clip_tagging_id
      game_clip_tag_id
      name
      category
      title
    }
    parent_ref_id
    parent_col_id
  }
}
    `;

/**
 * __useFullVideoByMomentQuery__
 *
 * To run a query within a React component, call `useFullVideoByMomentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullVideoByMomentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullVideoByMomentQuery({
 *   variables: {
 *      game_clip_id: // value for 'game_clip_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFullVideoByMomentQuery(baseOptions: Apollo.QueryHookOptions<FullVideoByMomentQuery, FullVideoByMomentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullVideoByMomentQuery, FullVideoByMomentQueryVariables>(FullVideoByMomentDocument, options);
      }
export function useFullVideoByMomentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullVideoByMomentQuery, FullVideoByMomentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullVideoByMomentQuery, FullVideoByMomentQueryVariables>(FullVideoByMomentDocument, options);
        }
export type FullVideoByMomentQueryHookResult = ReturnType<typeof useFullVideoByMomentQuery>;
export type FullVideoByMomentLazyQueryHookResult = ReturnType<typeof useFullVideoByMomentLazyQuery>;
export type FullVideoByMomentQueryResult = Apollo.QueryResult<FullVideoByMomentQuery, FullVideoByMomentQueryVariables>;
export const FullVideoMomentDocument = gql`
    query fullVideoMoment($collection_hash_key: String!, $user_playlist_clip_id: Int!, $token: UserToken!) {
  fullVideoMoment(
    collection_hash_key: $collection_hash_key
    user_playlist_clip_id: $user_playlist_clip_id
    token: $token
  ) {
    game_clip_id
    game_id
    team_id
    start_time
    base_path
    duration
    half
    time
    type
    dynamic_audio
    dynamic_duration
    dynamic_hls
    dynamic_jfile
    dynamic_offset
    dynamic_start
    sport_type
  }
}
    `;

/**
 * __useFullVideoMomentQuery__
 *
 * To run a query within a React component, call `useFullVideoMomentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullVideoMomentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullVideoMomentQuery({
 *   variables: {
 *      collection_hash_key: // value for 'collection_hash_key'
 *      user_playlist_clip_id: // value for 'user_playlist_clip_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFullVideoMomentQuery(baseOptions: Apollo.QueryHookOptions<FullVideoMomentQuery, FullVideoMomentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullVideoMomentQuery, FullVideoMomentQueryVariables>(FullVideoMomentDocument, options);
      }
export function useFullVideoMomentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullVideoMomentQuery, FullVideoMomentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullVideoMomentQuery, FullVideoMomentQueryVariables>(FullVideoMomentDocument, options);
        }
export type FullVideoMomentQueryHookResult = ReturnType<typeof useFullVideoMomentQuery>;
export type FullVideoMomentLazyQueryHookResult = ReturnType<typeof useFullVideoMomentLazyQuery>;
export type FullVideoMomentQueryResult = Apollo.QueryResult<FullVideoMomentQuery, FullVideoMomentQueryVariables>;
export const LatestNotificationsDocument = gql`
    query latestNotifications($token: UserToken!) {
  latestNotifications(token: $token) {
    msg_id
    msg_date
    message
    delivery {
      delivery_id
      user_id
      ext_user_id
      date_sent
      date_delivered
      date_read
      date_action
    }
    type
  }
}
    `;

/**
 * __useLatestNotificationsQuery__
 *
 * To run a query within a React component, call `useLatestNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestNotificationsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLatestNotificationsQuery(baseOptions: Apollo.QueryHookOptions<LatestNotificationsQuery, LatestNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestNotificationsQuery, LatestNotificationsQueryVariables>(LatestNotificationsDocument, options);
      }
export function useLatestNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestNotificationsQuery, LatestNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestNotificationsQuery, LatestNotificationsQueryVariables>(LatestNotificationsDocument, options);
        }
export type LatestNotificationsQueryHookResult = ReturnType<typeof useLatestNotificationsQuery>;
export type LatestNotificationsLazyQueryHookResult = ReturnType<typeof useLatestNotificationsLazyQuery>;
export type LatestNotificationsQueryResult = Apollo.QueryResult<LatestNotificationsQuery, LatestNotificationsQueryVariables>;
export const MomentDocument = gql`
    query moment($momentId: Int!, $userId: Int!, $teamName: String!) {
  moment(moment_id: $momentId, user_id: $userId, team_name: $teamName) {
    game_clip_id
    team_id
    game_id
    start_time
    base_path
    duration
    time
    type
    dynamic_duration
    dynamic_hls
    dynamic_jfile
    dynamic_offset
    dynamic_start
    parent_ref_id
    parent_col_id
    thirds
    keywords
    home_team {
      name
      abbr
      color
      score
      team_id
    }
    tags {
      game_clip_tagging_id
      game_clip_tag_id
      name
      title
    }
    away_team {
      team_id
      title
      abbr
      score
      color
    }
  }
}
    `;

/**
 * __useMomentQuery__
 *
 * To run a query within a React component, call `useMomentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentQuery({
 *   variables: {
 *      momentId: // value for 'momentId'
 *      userId: // value for 'userId'
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useMomentQuery(baseOptions: Apollo.QueryHookOptions<MomentQuery, MomentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentQuery, MomentQueryVariables>(MomentDocument, options);
      }
export function useMomentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentQuery, MomentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentQuery, MomentQueryVariables>(MomentDocument, options);
        }
export type MomentQueryHookResult = ReturnType<typeof useMomentQuery>;
export type MomentLazyQueryHookResult = ReturnType<typeof useMomentLazyQuery>;
export type MomentQueryResult = Apollo.QueryResult<MomentQuery, MomentQueryVariables>;
export const GetMomentCollectionInfoDocument = gql`
    query getMomentCollectionInfo($user_id: Int!, $game_clip_id: Int!, $token: UserToken!) {
  momentCollectionInfo(
    user_id: $user_id
    token: $token
    game_clip_id: $game_clip_id
  ) {
    game_clip_id
    user_playlist_clip_id
    user_playlist_id
    playlist_hash_key
    user_playlist_collection_id
    collection_hash_key
  }
}
    `;

/**
 * __useGetMomentCollectionInfoQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionInfoQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      game_clip_id: // value for 'game_clip_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetMomentCollectionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMomentCollectionInfoQuery, GetMomentCollectionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionInfoQuery, GetMomentCollectionInfoQueryVariables>(GetMomentCollectionInfoDocument, options);
      }
export function useGetMomentCollectionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionInfoQuery, GetMomentCollectionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionInfoQuery, GetMomentCollectionInfoQueryVariables>(GetMomentCollectionInfoDocument, options);
        }
export type GetMomentCollectionInfoQueryHookResult = ReturnType<typeof useGetMomentCollectionInfoQuery>;
export type GetMomentCollectionInfoLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionInfoLazyQuery>;
export type GetMomentCollectionInfoQueryResult = Apollo.QueryResult<GetMomentCollectionInfoQuery, GetMomentCollectionInfoQueryVariables>;
export const GetMomentCollectionsByUserAndGameDocument = gql`
    query getMomentCollectionsByUserAndGame($user_id: Int!, $game_id: Int!, $token: UserToken!) {
  momentCollectionsByUserAndGame(
    user_id: $user_id
    game_id: $game_id
    token: $token
  ) {
    game_clip_id
    playlist_clip_id
    title
    collection_hash_key
    profile_hash_key
  }
}
    `;

/**
 * __useGetMomentCollectionsByUserAndGameQuery__
 *
 * To run a query within a React component, call `useGetMomentCollectionsByUserAndGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMomentCollectionsByUserAndGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMomentCollectionsByUserAndGameQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      game_id: // value for 'game_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetMomentCollectionsByUserAndGameQuery(baseOptions: Apollo.QueryHookOptions<GetMomentCollectionsByUserAndGameQuery, GetMomentCollectionsByUserAndGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMomentCollectionsByUserAndGameQuery, GetMomentCollectionsByUserAndGameQueryVariables>(GetMomentCollectionsByUserAndGameDocument, options);
      }
export function useGetMomentCollectionsByUserAndGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMomentCollectionsByUserAndGameQuery, GetMomentCollectionsByUserAndGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMomentCollectionsByUserAndGameQuery, GetMomentCollectionsByUserAndGameQueryVariables>(GetMomentCollectionsByUserAndGameDocument, options);
        }
export type GetMomentCollectionsByUserAndGameQueryHookResult = ReturnType<typeof useGetMomentCollectionsByUserAndGameQuery>;
export type GetMomentCollectionsByUserAndGameLazyQueryHookResult = ReturnType<typeof useGetMomentCollectionsByUserAndGameLazyQuery>;
export type GetMomentCollectionsByUserAndGameQueryResult = Apollo.QueryResult<GetMomentCollectionsByUserAndGameQuery, GetMomentCollectionsByUserAndGameQueryVariables>;
export const NotificationActionDocument = gql`
    mutation notificationAction($message_ids: [Int]!, $actions: [NotificationAction]!, $token: UserToken!) {
  notificationAction(message_ids: $message_ids, actions: $actions, token: $token) {
    success
    error
  }
}
    `;
export type NotificationActionMutationFn = Apollo.MutationFunction<NotificationActionMutation, NotificationActionMutationVariables>;

/**
 * __useNotificationActionMutation__
 *
 * To run a mutation, you first call `useNotificationActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationActionMutation, { data, loading, error }] = useNotificationActionMutation({
 *   variables: {
 *      message_ids: // value for 'message_ids'
 *      actions: // value for 'actions'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useNotificationActionMutation(baseOptions?: Apollo.MutationHookOptions<NotificationActionMutation, NotificationActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationActionMutation, NotificationActionMutationVariables>(NotificationActionDocument, options);
      }
export type NotificationActionMutationHookResult = ReturnType<typeof useNotificationActionMutation>;
export type NotificationActionMutationResult = Apollo.MutationResult<NotificationActionMutation>;
export type NotificationActionMutationOptions = Apollo.BaseMutationOptions<NotificationActionMutation, NotificationActionMutationVariables>;
export const ProfileDocument = gql`
    query profile($hash_key: String!, $token: UserToken!) {
  profile(hash_key: $hash_key, token: $token) {
    user_playlist_id
    hash_key
    name
    user_id
    type
    description
    tagline
    image_url
    view_count
    contact
    test_score
    gpa
    grad_year
    positions
    facebook
    twitter
    instagram
    welcome_complete
    creation_time
    update_time
    permission {
      view
      edit
      create
      archive
      plan_type
      collections_limit
      family_access
    }
    collections {
      user_playlist_collection_id
      hash_key
      title
      public
      archived
      color
      position
      thumbnails
      creation_time
      update_time
      num_items
      locked
      color
      permission {
        view
        list
        edit
        archive
        items_copy
        items_move
        items_archive
        collection_items_limit
      }
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *      hash_key: // value for 'hash_key'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useProfileQuery(baseOptions: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const SendLoginCodeForShadowUserDocument = gql`
    mutation sendLoginCodeForShadowUser($user_id: Int!, $email_hash: String!, $proceed_url: String!, $auth_url: String!) {
  sendLoginCodeForShadowUser(
    user_id: $user_id
    email_hash: $email_hash
    proceed_url: $proceed_url
    auth_url: $auth_url
  ) {
    success
    error
  }
}
    `;
export type SendLoginCodeForShadowUserMutationFn = Apollo.MutationFunction<SendLoginCodeForShadowUserMutation, SendLoginCodeForShadowUserMutationVariables>;

/**
 * __useSendLoginCodeForShadowUserMutation__
 *
 * To run a mutation, you first call `useSendLoginCodeForShadowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLoginCodeForShadowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLoginCodeForShadowUserMutation, { data, loading, error }] = useSendLoginCodeForShadowUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      email_hash: // value for 'email_hash'
 *      proceed_url: // value for 'proceed_url'
 *      auth_url: // value for 'auth_url'
 *   },
 * });
 */
export function useSendLoginCodeForShadowUserMutation(baseOptions?: Apollo.MutationHookOptions<SendLoginCodeForShadowUserMutation, SendLoginCodeForShadowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendLoginCodeForShadowUserMutation, SendLoginCodeForShadowUserMutationVariables>(SendLoginCodeForShadowUserDocument, options);
      }
export type SendLoginCodeForShadowUserMutationHookResult = ReturnType<typeof useSendLoginCodeForShadowUserMutation>;
export type SendLoginCodeForShadowUserMutationResult = Apollo.MutationResult<SendLoginCodeForShadowUserMutation>;
export type SendLoginCodeForShadowUserMutationOptions = Apollo.BaseMutationOptions<SendLoginCodeForShadowUserMutation, SendLoginCodeForShadowUserMutationVariables>;
export const SurveysDocument = gql`
    query surveys($client_id: String!, $token: UserToken!, $team_id: Int) {
  surveys(client_id: $client_id, token: $token, team_id: $team_id) {
    rule_id
    question
    answers {
      detail_id
      title
    }
    settings
  }
}
    `;

/**
 * __useSurveysQuery__
 *
 * To run a query within a React component, call `useSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      token: // value for 'token'
 *      team_id: // value for 'team_id'
 *   },
 * });
 */
export function useSurveysQuery(baseOptions: Apollo.QueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
      }
export function useSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
        }
export type SurveysQueryHookResult = ReturnType<typeof useSurveysQuery>;
export type SurveysLazyQueryHookResult = ReturnType<typeof useSurveysLazyQuery>;
export type SurveysQueryResult = Apollo.QueryResult<SurveysQuery, SurveysQueryVariables>;
export const GetUserDocument = gql`
    query getUser($user_id: Int!, $token: UserToken!) {
  user(user_id: $user_id, token: $token) {
    user_id
    name
    email
    first_name
    last_name
    has_subscription
    acl {
      create_moment_tool
      traceid_v2
    }
    recent_games {
      game_id
      home_team {
        team_id
        created_user_id
        name
        title
        abbr
        players_gender
        players_birth_year
        score
        content_access
      }
      away_team {
        team_id
        created_user_id
        name
        title
        abbr
        players_gender
        players_birth_year
        score
        content_access
      }
      full_date
      approx_half_duration
    }
    divisions {
      division_id
      is_member
      title
      type
      teams {
        team_id
        created_user_id
        name
        title
        abbr
        players_gender
        players_birth_year
        creation_time
        update_time
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserDivisionDocument = gql`
    query getUserDivision($user_id: Int!, $token: UserToken!) {
  user(user_id: $user_id, token: $token) {
    user_id
    email
    recent_division_id
  }
}
    `;

/**
 * __useGetUserDivisionQuery__
 *
 * To run a query within a React component, call `useGetUserDivisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDivisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDivisionQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetUserDivisionQuery(baseOptions: Apollo.QueryHookOptions<GetUserDivisionQuery, GetUserDivisionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDivisionQuery, GetUserDivisionQueryVariables>(GetUserDivisionDocument, options);
      }
export function useGetUserDivisionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDivisionQuery, GetUserDivisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDivisionQuery, GetUserDivisionQueryVariables>(GetUserDivisionDocument, options);
        }
export type GetUserDivisionQueryHookResult = ReturnType<typeof useGetUserDivisionQuery>;
export type GetUserDivisionLazyQueryHookResult = ReturnType<typeof useGetUserDivisionLazyQuery>;
export type GetUserDivisionQueryResult = Apollo.QueryResult<GetUserDivisionQuery, GetUserDivisionQueryVariables>;
export const GetUserNamesDocument = gql`
    query getUserNames($user_id: Int!, $email_hash: String!) {
  userNames(user_id: $user_id, email_hash: $email_hash) {
    first_name
    last_name
    email
    name
  }
}
    `;

/**
 * __useGetUserNamesQuery__
 *
 * To run a query within a React component, call `useGetUserNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNamesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      email_hash: // value for 'email_hash'
 *   },
 * });
 */
export function useGetUserNamesQuery(baseOptions: Apollo.QueryHookOptions<GetUserNamesQuery, GetUserNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNamesQuery, GetUserNamesQueryVariables>(GetUserNamesDocument, options);
      }
export function useGetUserNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNamesQuery, GetUserNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNamesQuery, GetUserNamesQueryVariables>(GetUserNamesDocument, options);
        }
export type GetUserNamesQueryHookResult = ReturnType<typeof useGetUserNamesQuery>;
export type GetUserNamesLazyQueryHookResult = ReturnType<typeof useGetUserNamesLazyQuery>;
export type GetUserNamesQueryResult = Apollo.QueryResult<GetUserNamesQuery, GetUserNamesQueryVariables>;
export const GetUserRelationsDocument = gql`
    query getUserRelations($to_user_id: Int!, $token: UserToken!, $include_self: Boolean) {
  userRelations(
    to_user_id: $to_user_id
    token: $token
    include_self: $include_self
  ) {
    user_id
    user {
      image_url
      masked_email
      email
      first_name
      last_name
      user_id
    }
    relation
  }
}
    `;

/**
 * __useGetUserRelationsQuery__
 *
 * To run a query within a React component, call `useGetUserRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRelationsQuery({
 *   variables: {
 *      to_user_id: // value for 'to_user_id'
 *      token: // value for 'token'
 *      include_self: // value for 'include_self'
 *   },
 * });
 */
export function useGetUserRelationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserRelationsQuery, GetUserRelationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRelationsQuery, GetUserRelationsQueryVariables>(GetUserRelationsDocument, options);
      }
export function useGetUserRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRelationsQuery, GetUserRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRelationsQuery, GetUserRelationsQueryVariables>(GetUserRelationsDocument, options);
        }
export type GetUserRelationsQueryHookResult = ReturnType<typeof useGetUserRelationsQuery>;
export type GetUserRelationsLazyQueryHookResult = ReturnType<typeof useGetUserRelationsLazyQuery>;
export type GetUserRelationsQueryResult = Apollo.QueryResult<GetUserRelationsQuery, GetUserRelationsQueryVariables>;
export const UserRoleDocument = gql`
    query userRole($token: UserToken!) {
  userRole(token: $token)
}
    `;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions: Apollo.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;